import React, { useState, KeyboardEvent } from 'react';
import './KeywordInput.css';

interface KeywordInputProps {
  keywords: string[];
  onChange: (keywords: string[]) => void;
}

export const KeywordInput: React.FC<KeywordInputProps> = ({ keywords, onChange }) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addKeyword();
    } else if (e.key === 'Backspace' && inputValue === '' && keywords.length > 0) {
      removeKeyword(keywords.length - 1);
    }
  };

  const addKeyword = () => {
    const trimmedValue = inputValue.trim();
    if (trimmedValue && !keywords.includes(trimmedValue)) {
      onChange([...keywords, trimmedValue]);
      setInputValue('');
    }
  };

  const removeKeyword = (index: number) => {
    onChange(keywords.filter((_, i) => i !== index));
  };

  return (
    <div className="keywords-container">
      {keywords.map((keyword, index) => (
        <span key={index} className="keyword">
          {keyword}
          <button
            type="button"
            className="remove-keyword"
            onClick={() => removeKeyword(index)}
          >
            ×
          </button>
        </span>
      ))}
      <input
        type="text"
        className="keyword-input"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={addKeyword}
        placeholder={keywords.length === 0 ? "Digite palavras-chave e pressione Enter" : ""}
      />
    </div>
  );
}; 